import { render, staticRenderFns } from "./TagKeyValueManageMenu.vue?vue&type=template&id=18d462e5&"
import script from "./TagKeyValueManageMenu.vue?vue&type=script&lang=js&"
export * from "./TagKeyValueManageMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TagKeyValueManageMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports